import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 検索条件管理
const slice = createSlice({
    name: 'SearchResultOffsetData',
    // 初期値
    initialState: 0,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<number>) => action.payload,
        // 初期化
        initState: () => 0,
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
